<template>
  <div class="story-campaign-group-item">
    <AppRouteLink class="story-campaign-group-item__link" :route-to="routeTo">
      <div class="story-campaign-group-item__image-wrapper">
        <div class="story-campaign-group-item__image" :style="`background-image:url(${media})`" />

        <EntityCardLabel v-if="entityCardLabel" :label="entityCardLabel" />
      </div>

      <h3 class="story-campaign-group-item__title">{{ item.title }}</h3>

      <div>
        <DataItemDates :dates="dates" />
        <div v-if="item.category" class="small-grey">{{ item.category }}</div>

        <div v-if="item.destination" class="d-flex">
          <div v-if="item.destination.title" class="small-grey">{{ item.destination.title }},</div>
          <div v-if="item.destination.country" class="small-grey ml-1">{{ item.destination.country }}</div>
        </div>
      </div>
    </AppRouteLink>
  </div>
</template>

<script>
import { getEntityRoute } from '@/helpers/entityType';
import ImageHandler from '@/helpers/ImageHandler';
import { getEntityCardLabel } from '@/helpers/entityCardLabel';

import DataItemDates from '@/components/partials/DataItemDates';
import TheFavoritesIcon from '@/components/partials/TheFavoritesIcon';
import AppRouteLink from '@/components/partials/AppRouteLink';
import EntityCardLabel from '@/components/partials/EntityCardLabel.vue';

export default {
  name: 'StoryCampaignGroupItem',
  components: {
    EntityCardLabel,
    AppRouteLink,
    TheFavoritesIcon,
    DataItemDates,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dates() {
      if (this.item.date && this.item.date.length) {
        return this.item.date;
      }
      return [
        {
          start_date: this.item.start_date || null,
          end_date: this.item.end_date || null,
        },
      ];
    },
    entityCardLabel() {
      return getEntityCardLabel(this.item);
    },
    media() {
      return new ImageHandler().getFirstImgFromMedia(this.item);
    },
    routeTo() {
      return getEntityRoute(this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.story-campaign-group-item {
  $item: &;

  position: relative;

  &__link {
    color: inherit;
  }

  &__image {
    &-wrapper {
      position: relative;
    }

    height: 220px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: vars.$c-gray-d8;
    transition: all 0.3s linear;

    @media (min-width: vars.$tablet-break-point) {
      height: 225px;
    }
    @media (min-width: vars.$desktop-lg-992-break-point) {
      height: 250px;
    }
  }
  a#{$item}__link:hover &__image {
    transform: scale(0.95);
  }

  &__title {
    margin: 20px 0 10px;
    font-family: 'Futura PT', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: 1px;
    text-transform: uppercase;

    @media (min-width: vars.$tablet-break-point) {
      font-size: 22px;
    }
  }
}
</style>
